//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../axios-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './AssetsClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type AssetsGetListAssetsQueryParameters = {
  filter?: string | undefined ;
  type?: Types.AssetType[] | undefined ;
  dataSource?: Types.DataSource[] | undefined ;
  sorting?: string | undefined ;
  skipCount?: number | undefined ;
  maxResultCount?: number | undefined ;
}

export type AssetsGetAssetsQueryParameters = {
  id: string ;
}

export type AssetsGetEventsAssetsQueryParameters = {
  id: string ;
}

export type AssetsSearchV2AssetsQueryParameters = {
  searchTerm: string ;
  assetTypes: Types.AssetType[] ;
  maxResultCount?: number | undefined ;
}

export type AssetsGetChartAssetsQueryParameters = {
  identifier: string ;
  dataSource: Types.DataSource ;
  start?: string | undefined ;
  end?: string | undefined ;
}

export type AssetsGetChartByIdAssetsQueryParameters = {
  id: string ;
  start?: string | undefined ;
  end?: string | undefined ;
}

export function assetsGetListUrl(filter?: string | undefined, type?: Types.AssetType[] | undefined, dataSource?: Types.DataSource[] | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/assets?";
if (filter === null)
    throw new Error("The parameter 'filter' cannot be null.");
else if (filter !== undefined)
    url_ += "Filter=" + encodeURIComponent("" + filter) + "&";
if (type === null)
    throw new Error("The parameter 'type' cannot be null.");
else if (type !== undefined)
    type && type.forEach(item => { url_ += "Type=" + encodeURIComponent("" + item) + "&"; });
if (dataSource === null)
    throw new Error("The parameter 'dataSource' cannot be null.");
else if (dataSource !== undefined)
    dataSource && dataSource.forEach(item => { url_ += "DataSource=" + encodeURIComponent("" + item) + "&"; });
if (sorting === null)
    throw new Error("The parameter 'sorting' cannot be null.");
else if (sorting !== undefined)
    url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
if (skipCount === null)
    throw new Error("The parameter 'skipCount' cannot be null.");
else if (skipCount !== undefined)
    url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
if (maxResultCount === null)
    throw new Error("The parameter 'maxResultCount' cannot be null.");
else if (maxResultCount !== undefined)
    url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let assetsGetListDefaultOptions: Omit<UseQueryOptions<Types.PagedResultDtoOfAdminAssetDto, unknown, Types.PagedResultDtoOfAdminAssetDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PagedResultDtoOfAdminAssetDto, unknown, Types.PagedResultDtoOfAdminAssetDto>, 'queryFn'>> = {
};
export function getAssetsGetListDefaultOptions() {
  return assetsGetListDefaultOptions;
};
export function setAssetsGetListDefaultOptions(options: typeof assetsGetListDefaultOptions) {
  assetsGetListDefaultOptions = options;
}

export function assetsGetListQueryKey(dto: AssetsGetListAssetsQueryParameters): QueryKey;
export function assetsGetListQueryKey(filter?: string | undefined, type?: Types.AssetType[] | undefined, dataSource?: Types.DataSource[] | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined): QueryKey;
export function assetsGetListQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { filter, type, dataSource, sorting, skipCount, maxResultCount,  } = params[0] as AssetsGetListAssetsQueryParameters;

    return trimArrayEnd([
        'AssetsClient',
        'assetsGetList',
        filter as any,
        type as any,
        dataSource as any,
        sorting as any,
        skipCount as any,
        maxResultCount as any,
      ]);
  } else {
    return trimArrayEnd([
        'AssetsClient',
        'assetsGetList',
        ...params
      ]);
  }
}
export function __assetsGetList(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.assetsGetList(
      context.queryKey[2] as string | undefined,       context.queryKey[3] as Types.AssetType[] | undefined,       context.queryKey[4] as Types.DataSource[] | undefined,       context.queryKey[5] as string | undefined,       context.queryKey[6] as number | undefined,       context.queryKey[7] as number | undefined,axiosConfig    );
}

export function useAssetsGetListQuery<TSelectData = Types.PagedResultDtoOfAdminAssetDto, TError = unknown>(dto: AssetsGetListAssetsQueryParameters, options?: Omit<UseQueryOptions<Types.PagedResultDtoOfAdminAssetDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param filter (optional) 
 * @param type (optional) 
 * @param dataSource (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function useAssetsGetListQuery<TSelectData = Types.PagedResultDtoOfAdminAssetDto, TError = unknown>(filter?: string | undefined, type?: Types.AssetType[] | undefined, dataSource?: Types.DataSource[] | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined, options?: Omit<UseQueryOptions<Types.PagedResultDtoOfAdminAssetDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useAssetsGetListQuery<TSelectData = Types.PagedResultDtoOfAdminAssetDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultDtoOfAdminAssetDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let filter: any = undefined;
  let type: any = undefined;
  let dataSource: any = undefined;
  let sorting: any = undefined;
  let skipCount: any = undefined;
  let maxResultCount: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ filter, type, dataSource, sorting, skipCount, maxResultCount,  } = params[0] as AssetsGetListAssetsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [filter, type, dataSource, sorting, skipCount, maxResultCount, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PagedResultDtoOfAdminAssetDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __assetsGetList(context, axiosConfig) : __assetsGetList,
    queryKey: assetsGetListQueryKey(filter, type, dataSource, sorting, skipCount, maxResultCount),
    ...assetsGetListDefaultOptions as unknown as Omit<UseQueryOptions<Types.PagedResultDtoOfAdminAssetDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param filter (optional) 
 * @param type (optional) 
 * @param dataSource (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function setAssetsGetListData(queryClient: QueryClient, updater: (data: Types.PagedResultDtoOfAdminAssetDto | undefined) => Types.PagedResultDtoOfAdminAssetDto, filter?: string | undefined, type?: Types.AssetType[] | undefined, dataSource?: Types.DataSource[] | undefined, sorting?: string | undefined, skipCount?: number | undefined, maxResultCount?: number | undefined) {
  queryClient.setQueryData(assetsGetListQueryKey(filter, type, dataSource, sorting, skipCount, maxResultCount),
    updater
  );
}

/**
 * @param filter (optional) 
 * @param type (optional) 
 * @param dataSource (optional) 
 * @param sorting (optional) 
 * @param skipCount (optional) 
 * @param maxResultCount (optional) 
 * @return OK
 */
export function setAssetsGetListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultDtoOfAdminAssetDto | undefined) => Types.PagedResultDtoOfAdminAssetDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function assetsGetUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/assets/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let assetsGetDefaultOptions: Omit<UseQueryOptions<Types.AssetDto, unknown, Types.AssetDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.AssetDto, unknown, Types.AssetDto>, 'queryFn'>> = {
};
export function getAssetsGetDefaultOptions() {
  return assetsGetDefaultOptions;
};
export function setAssetsGetDefaultOptions(options: typeof assetsGetDefaultOptions) {
  assetsGetDefaultOptions = options;
}

export function assetsGetQueryKey(id: string): QueryKey;
export function assetsGetQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as AssetsGetAssetsQueryParameters;

    return trimArrayEnd([
        'AssetsClient',
        'assetsGet',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'AssetsClient',
        'assetsGet',
        ...params
      ]);
  }
}
export function __assetsGet(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.assetsGet(
      context.queryKey[2] as string,axiosConfig    );
}

export function useAssetsGetQuery<TSelectData = Types.AssetDto, TError = unknown>(dto: AssetsGetAssetsQueryParameters, options?: Omit<UseQueryOptions<Types.AssetDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useAssetsGetQuery<TSelectData = Types.AssetDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.AssetDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useAssetsGetQuery<TSelectData = Types.AssetDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.AssetDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as AssetsGetAssetsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.AssetDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __assetsGet(context, axiosConfig) : __assetsGet,
    queryKey: assetsGetQueryKey(id),
    ...assetsGetDefaultOptions as unknown as Omit<UseQueryOptions<Types.AssetDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setAssetsGetData(queryClient: QueryClient, updater: (data: Types.AssetDto | undefined) => Types.AssetDto, id: string) {
  queryClient.setQueryData(assetsGetQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setAssetsGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.AssetDto | undefined) => Types.AssetDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function assetsGetEventsUrl(id: string): string {
  let url_ = getBaseUrl() + "/api/assets/{id}/events";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let assetsGetEventsDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfAssetEventDto, unknown, Types.ListResultDtoOfAssetEventDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfAssetEventDto, unknown, Types.ListResultDtoOfAssetEventDto>, 'queryFn'>> = {
};
export function getAssetsGetEventsDefaultOptions() {
  return assetsGetEventsDefaultOptions;
};
export function setAssetsGetEventsDefaultOptions(options: typeof assetsGetEventsDefaultOptions) {
  assetsGetEventsDefaultOptions = options;
}

export function assetsGetEventsQueryKey(id: string): QueryKey;
export function assetsGetEventsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as AssetsGetEventsAssetsQueryParameters;

    return trimArrayEnd([
        'AssetsClient',
        'assetsGetEvents',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'AssetsClient',
        'assetsGetEvents',
        ...params
      ]);
  }
}
export function __assetsGetEvents(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.assetsGetEvents(
      context.queryKey[2] as string,axiosConfig    );
}

export function useAssetsGetEventsQuery<TSelectData = Types.ListResultDtoOfAssetEventDto, TError = unknown>(dto: AssetsGetEventsAssetsQueryParameters, options?: Omit<UseQueryOptions<Types.ListResultDtoOfAssetEventDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @return OK
 */
export function useAssetsGetEventsQuery<TSelectData = Types.ListResultDtoOfAssetEventDto, TError = unknown>(id: string, options?: Omit<UseQueryOptions<Types.ListResultDtoOfAssetEventDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useAssetsGetEventsQuery<TSelectData = Types.ListResultDtoOfAssetEventDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfAssetEventDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as AssetsGetEventsAssetsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfAssetEventDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __assetsGetEvents(context, axiosConfig) : __assetsGetEvents,
    queryKey: assetsGetEventsQueryKey(id),
    ...assetsGetEventsDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfAssetEventDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @return OK
 */
export function setAssetsGetEventsData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfAssetEventDto | undefined) => Types.ListResultDtoOfAssetEventDto, id: string) {
  queryClient.setQueryData(assetsGetEventsQueryKey(id),
    updater
  );
}

/**
 * @return OK
 */
export function setAssetsGetEventsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfAssetEventDto | undefined) => Types.ListResultDtoOfAssetEventDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function assetsSearchUrl(): string {
  let url_ = getBaseUrl() + "/api/assets/search";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function assetsSearchMutationKey(): MutationKey {
  return trimArrayEnd([
      'AssetsClient',
      'assetsSearch',
    ]);
}

/**
 * @param body (optional) 
 * @return OK
 */
export function useAssetsSearchMutation<TContext>(options?: Omit<UseMutationOptions<Types.ExternalAssetSearchDto[], unknown, Types.AssetSearchInput, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.ExternalAssetSearchDto[], unknown, Types.AssetSearchInput, TContext> {
  const key = assetsSearchMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (body: Types.AssetSearchInput) => Client.assetsSearch(body),
    mutationKey: key,
  });
}
  
export function assetsSearchV2Url(searchTerm: string, assetTypes: Types.AssetType[], maxResultCount?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/assets/search?";
  if (searchTerm === undefined || searchTerm === null)
    throw new Error("The parameter 'searchTerm' must be defined and cannot be null.");
  else
    url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
  if (assetTypes === undefined || assetTypes === null)
    throw new Error("The parameter 'assetTypes' must be defined and cannot be null.");
  else
    assetTypes && assetTypes.forEach(item => { url_ += "AssetTypes=" + encodeURIComponent("" + item) + "&"; });
if (maxResultCount === null)
    throw new Error("The parameter 'maxResultCount' cannot be null.");
else if (maxResultCount !== undefined)
    url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let assetsSearchV2DefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfExternalAssetSearchDto, unknown, Types.ListResultDtoOfExternalAssetSearchDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfExternalAssetSearchDto, unknown, Types.ListResultDtoOfExternalAssetSearchDto>, 'queryFn'>> = {
};
export function getAssetsSearchV2DefaultOptions() {
  return assetsSearchV2DefaultOptions;
};
export function setAssetsSearchV2DefaultOptions(options: typeof assetsSearchV2DefaultOptions) {
  assetsSearchV2DefaultOptions = options;
}

export function assetsSearchV2QueryKey(dto: AssetsSearchV2AssetsQueryParameters): QueryKey;
export function assetsSearchV2QueryKey(searchTerm: string, assetTypes: Types.AssetType[], maxResultCount?: number | undefined): QueryKey;
export function assetsSearchV2QueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { searchTerm, assetTypes, maxResultCount,  } = params[0] as AssetsSearchV2AssetsQueryParameters;

    return trimArrayEnd([
        'AssetsClient',
        'assetsSearchV2',
        searchTerm as any,
        assetTypes as any,
        maxResultCount as any,
      ]);
  } else {
    return trimArrayEnd([
        'AssetsClient',
        'assetsSearchV2',
        ...params
      ]);
  }
}
export function __assetsSearchV2(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.assetsSearchV2(
      context.queryKey[2] as string,       context.queryKey[3] as Types.AssetType[],       context.queryKey[4] as number | undefined,axiosConfig    );
}

export function useAssetsSearchV2Query<TSelectData = Types.ListResultDtoOfExternalAssetSearchDto, TError = unknown>(dto: AssetsSearchV2AssetsQueryParameters, options?: Omit<UseQueryOptions<Types.ListResultDtoOfExternalAssetSearchDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param maxResultCount (optional) 
 * @return OK
 */
export function useAssetsSearchV2Query<TSelectData = Types.ListResultDtoOfExternalAssetSearchDto, TError = unknown>(searchTerm: string, assetTypes: Types.AssetType[], maxResultCount?: number | undefined, options?: Omit<UseQueryOptions<Types.ListResultDtoOfExternalAssetSearchDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useAssetsSearchV2Query<TSelectData = Types.ListResultDtoOfExternalAssetSearchDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfExternalAssetSearchDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let searchTerm: any = undefined;
  let assetTypes: any = undefined;
  let maxResultCount: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ searchTerm, assetTypes, maxResultCount,  } = params[0] as AssetsSearchV2AssetsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [searchTerm, assetTypes, maxResultCount, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfExternalAssetSearchDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __assetsSearchV2(context, axiosConfig) : __assetsSearchV2,
    queryKey: assetsSearchV2QueryKey(searchTerm, assetTypes, maxResultCount),
    ...assetsSearchV2DefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfExternalAssetSearchDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param maxResultCount (optional) 
 * @return OK
 */
export function setAssetsSearchV2Data(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfExternalAssetSearchDto | undefined) => Types.ListResultDtoOfExternalAssetSearchDto, searchTerm: string, assetTypes: Types.AssetType[], maxResultCount?: number | undefined) {
  queryClient.setQueryData(assetsSearchV2QueryKey(searchTerm, assetTypes, maxResultCount),
    updater
  );
}

/**
 * @param maxResultCount (optional) 
 * @return OK
 */
export function setAssetsSearchV2DataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfExternalAssetSearchDto | undefined) => Types.ListResultDtoOfExternalAssetSearchDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function assetsGetChartUrl(identifier: string, dataSource: Types.DataSource, start?: string | undefined, end?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/assets/chart?";
  if (identifier === undefined || identifier === null)
    throw new Error("The parameter 'identifier' must be defined and cannot be null.");
  else
    url_ += "Identifier=" + encodeURIComponent("" + identifier) + "&";
  if (dataSource === undefined || dataSource === null)
    throw new Error("The parameter 'dataSource' must be defined and cannot be null.");
  else
    url_ += "DataSource=" + encodeURIComponent("" + dataSource) + "&";
if (start === null)
    throw new Error("The parameter 'start' cannot be null.");
else if (start !== undefined)
    url_ += "Start=" + encodeURIComponent("" + start) + "&";
if (end === null)
    throw new Error("The parameter 'end' cannot be null.");
else if (end !== undefined)
    url_ += "End=" + encodeURIComponent("" + end) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let assetsGetChartDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfAssetTimeSeriesEntryDto, unknown, Types.ListResultDtoOfAssetTimeSeriesEntryDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfAssetTimeSeriesEntryDto, unknown, Types.ListResultDtoOfAssetTimeSeriesEntryDto>, 'queryFn'>> = {
};
export function getAssetsGetChartDefaultOptions() {
  return assetsGetChartDefaultOptions;
};
export function setAssetsGetChartDefaultOptions(options: typeof assetsGetChartDefaultOptions) {
  assetsGetChartDefaultOptions = options;
}

export function assetsGetChartQueryKey(dto: AssetsGetChartAssetsQueryParameters): QueryKey;
export function assetsGetChartQueryKey(identifier: string, dataSource: Types.DataSource, start?: string | undefined, end?: string | undefined): QueryKey;
export function assetsGetChartQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { identifier, dataSource, start, end,  } = params[0] as AssetsGetChartAssetsQueryParameters;

    return trimArrayEnd([
        'AssetsClient',
        'assetsGetChart',
        identifier as any,
        dataSource as any,
        start as any,
        end as any,
      ]);
  } else {
    return trimArrayEnd([
        'AssetsClient',
        'assetsGetChart',
        ...params
      ]);
  }
}
export function __assetsGetChart(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.assetsGetChart(
      context.queryKey[2] as string,       context.queryKey[3] as Types.DataSource,       context.queryKey[4] as string | undefined,       context.queryKey[5] as string | undefined,axiosConfig    );
}

export function useAssetsGetChartQuery<TSelectData = Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError = unknown>(dto: AssetsGetChartAssetsQueryParameters, options?: Omit<UseQueryOptions<Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param start (optional) 
 * @param end (optional) 
 * @return OK
 */
export function useAssetsGetChartQuery<TSelectData = Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError = unknown>(identifier: string, dataSource: Types.DataSource, start?: string | undefined, end?: string | undefined, options?: Omit<UseQueryOptions<Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useAssetsGetChartQuery<TSelectData = Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let identifier: any = undefined;
  let dataSource: any = undefined;
  let start: any = undefined;
  let end: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ identifier, dataSource, start, end,  } = params[0] as AssetsGetChartAssetsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [identifier, dataSource, start, end, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __assetsGetChart(context, axiosConfig) : __assetsGetChart,
    queryKey: assetsGetChartQueryKey(identifier, dataSource, start, end),
    ...assetsGetChartDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param start (optional) 
 * @param end (optional) 
 * @return OK
 */
export function setAssetsGetChartData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfAssetTimeSeriesEntryDto | undefined) => Types.ListResultDtoOfAssetTimeSeriesEntryDto, identifier: string, dataSource: Types.DataSource, start?: string | undefined, end?: string | undefined) {
  queryClient.setQueryData(assetsGetChartQueryKey(identifier, dataSource, start, end),
    updater
  );
}

/**
 * @param start (optional) 
 * @param end (optional) 
 * @return OK
 */
export function setAssetsGetChartDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfAssetTimeSeriesEntryDto | undefined) => Types.ListResultDtoOfAssetTimeSeriesEntryDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function assetsGetChartByIdUrl(id: string, start?: string | undefined, end?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/assets/{id}/chart?";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
if (start === null)
    throw new Error("The parameter 'start' cannot be null.");
else if (start !== undefined)
    url_ += "Start=" + encodeURIComponent("" + start) + "&";
if (end === null)
    throw new Error("The parameter 'end' cannot be null.");
else if (end !== undefined)
    url_ += "End=" + encodeURIComponent("" + end) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let assetsGetChartByIdDefaultOptions: Omit<UseQueryOptions<Types.ListResultDtoOfAssetTimeSeriesEntryDto, unknown, Types.ListResultDtoOfAssetTimeSeriesEntryDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.ListResultDtoOfAssetTimeSeriesEntryDto, unknown, Types.ListResultDtoOfAssetTimeSeriesEntryDto>, 'queryFn'>> = {
};
export function getAssetsGetChartByIdDefaultOptions() {
  return assetsGetChartByIdDefaultOptions;
};
export function setAssetsGetChartByIdDefaultOptions(options: typeof assetsGetChartByIdDefaultOptions) {
  assetsGetChartByIdDefaultOptions = options;
}

export function assetsGetChartByIdQueryKey(dto: AssetsGetChartByIdAssetsQueryParameters): QueryKey;
export function assetsGetChartByIdQueryKey(id: string, start?: string | undefined, end?: string | undefined): QueryKey;
export function assetsGetChartByIdQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id, start, end,  } = params[0] as AssetsGetChartByIdAssetsQueryParameters;

    return trimArrayEnd([
        'AssetsClient',
        'assetsGetChartById',
        id as any,
        start as any,
        end as any,
      ]);
  } else {
    return trimArrayEnd([
        'AssetsClient',
        'assetsGetChartById',
        ...params
      ]);
  }
}
export function __assetsGetChartById(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.assetsGetChartById(
      context.queryKey[2] as string,       context.queryKey[3] as string | undefined,       context.queryKey[4] as string | undefined,axiosConfig    );
}

export function useAssetsGetChartByIdQuery<TSelectData = Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError = unknown>(dto: AssetsGetChartByIdAssetsQueryParameters, options?: Omit<UseQueryOptions<Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * @param start (optional) 
 * @param end (optional) 
 * @return OK
 */
export function useAssetsGetChartByIdQuery<TSelectData = Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError = unknown>(id: string, start?: string | undefined, end?: string | undefined, options?: Omit<UseQueryOptions<Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useAssetsGetChartByIdQuery<TSelectData = Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  let start: any = undefined;
  let end: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id, start, end,  } = params[0] as AssetsGetChartByIdAssetsQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, start, end, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __assetsGetChartById(context, axiosConfig) : __assetsGetChartById,
    queryKey: assetsGetChartByIdQueryKey(id, start, end),
    ...assetsGetChartByIdDefaultOptions as unknown as Omit<UseQueryOptions<Types.ListResultDtoOfAssetTimeSeriesEntryDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * @param start (optional) 
 * @param end (optional) 
 * @return OK
 */
export function setAssetsGetChartByIdData(queryClient: QueryClient, updater: (data: Types.ListResultDtoOfAssetTimeSeriesEntryDto | undefined) => Types.ListResultDtoOfAssetTimeSeriesEntryDto, id: string, start?: string | undefined, end?: string | undefined) {
  queryClient.setQueryData(assetsGetChartByIdQueryKey(id, start, end),
    updater
  );
}

/**
 * @param start (optional) 
 * @param end (optional) 
 * @return OK
 */
export function setAssetsGetChartByIdDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.ListResultDtoOfAssetTimeSeriesEntryDto | undefined) => Types.ListResultDtoOfAssetTimeSeriesEntryDto) {
  queryClient.setQueryData(queryKey, updater);
}